var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal modal-filter-details fade",
      attrs: {
        id: "modal-add-talent-manager",
        role: "dialog",
        "aria-labelledby": "shortlist-modal-label",
        "aria-hidden": "true",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.closeModal,
              expression: "closeModal",
            },
          ],
          staticClass: "modal-dialog",
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "h4",
                {
                  staticClass: "modal-title",
                  attrs: { id: "shortlist-modal-label" },
                },
                [
                  [
                    _vm._v(
                      "Apply For " +
                        _vm._s(_vm._f("sentenceCase")(_vm.$starLabel))
                    ),
                  ],
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _c(
                  "form",
                  {
                    staticClass: "form-horizontal",
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    this.tagNames
                      ? _c("p", [
                          _vm._v(
                            "You will only be able to apply for " +
                              _vm._s(
                                _vm._f("sentenceCase")(_vm.$starLabelPlural)
                              ) +
                              " with the following tags for this request: " +
                              _vm._s(this.tagNames)
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("label", { staticClass: "sr-only" }, [
                      _vm._v(
                        "Search for " +
                          _vm._s(_vm._f("sentenceCase")(_vm.$starLabelPlural))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.search.name,
                            expression: "search.name",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          placeholder:
                            _vm.$options.filters.sentenceCase(_vm.$starLabel) +
                            " Name...",
                        },
                        domProps: { value: _vm.search.name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.search, "name", $event.target.value)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "input-group-btn" },
                        [
                          _c(
                            "ladda-button",
                            {
                              ref: "search",
                              staticClass: "btn btn-dark",
                              attrs: {
                                type: "submit",
                                click: _vm.handleSearchTalentCallback,
                              },
                            },
                            [_vm._v("\n                Search\n              ")]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _vm.haveNoTalentWithoutExisting && _vm.notSearching
                      ? _c("div", { staticClass: "text-center" }, [
                          _c("h5", [
                            _vm._v(
                              "There are no talent. Try searching to find who you want."
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.haveSearchText
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-default btn-sm",
                                  on: { click: _vm.handleClearSearchCallback },
                                },
                                [_vm._v("Clear Search")]
                              )
                            : _vm._e(),
                        ])
                      : _c(
                          "ul",
                          { staticClass: "shortlist-modal-results" },
                          _vm._l(_vm.talentWithoutExisting, function (talent) {
                            return _c(
                              "li",
                              { key: talent.id, staticClass: "row" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-xs-3 col-sm-2" },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: talent.profile_image_url,
                                        alt: "",
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-xs-6 col-sm-8" },
                                  [
                                    _c("div", { staticClass: "details" }, [
                                      _c("p", [
                                        _c("strong", [
                                          _vm._v(_vm._s(talent.name) + " "),
                                          _c("i", {
                                            staticClass: "fa",
                                            class: {
                                              "fa-lock":
                                                talent.profile.visibility ===
                                                "private",
                                              "fa-eye-slash":
                                                talent.profile.visibility ===
                                                "hidden",
                                            },
                                          }),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(_vm._s(talent.profile.tagline)),
                                      ]),
                                      _vm._v(" "),
                                      talent.date_applied_for
                                        ? _c("span", { staticClass: "tag" }, [
                                            _vm._v(
                                              "Applied For " +
                                                _vm._s(
                                                  _vm._f("date")(
                                                    talent.date_applied_for,
                                                    _vm.$user
                                                      .date_format_preference
                                                  )
                                                )
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.booking.has_date_options_only
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-3 col-sm-2 btn-group",
                                      },
                                      [
                                        _vm.talentIsAlreadyAdded(talent)
                                          ? _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "btn btn-lg btn-success",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleRemoveTalentCallback(
                                                      talent
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-fw fa-check",
                                                }),
                                              ]
                                            )
                                          : _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "btn btn-lg btn-default",
                                                attrs: {
                                                  "data-toggle": "dropdown",
                                                  "aria-haspopup": "true",
                                                  "aria-expanded": "false",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-fw fa-plus",
                                                }),
                                              ]
                                            ),
                                        _vm._v(" "),
                                        _c(
                                          "ul",
                                          {
                                            staticClass: "dropdown-menu title",
                                            attrs: {
                                              id: "dropdown-menu-" + talent.id,
                                            },
                                          },
                                          [
                                            _c("li", [
                                              _vm._v("Select a preferred date"),
                                            ]),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.booking.date_options,
                                              function (date) {
                                                return _c("li", { key: date }, [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "hover",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleAddTalentCallback(
                                                            talent,
                                                            date
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("date")(
                                                            date,
                                                            _vm.$user
                                                              .date_format_preference
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ])
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      { staticClass: "col-xs-3 col-sm-2" },
                                      [
                                        _vm.talentIsAlreadyAdded(talent)
                                          ? _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "btn btn-lg btn-success",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleRemoveTalentCallback(
                                                      talent
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-fw fa-check",
                                                }),
                                              ]
                                            )
                                          : _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "btn btn-lg btn-default",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleAddTalentCallback(
                                                      talent
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-fw fa-plus",
                                                }),
                                              ]
                                            ),
                                      ]
                                    ),
                              ]
                            )
                          }),
                          0
                        ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "lazy-loading",
                  {
                    ref: "lazyLoading",
                    staticClass: "text-center",
                    attrs: {
                      "scroll-target": ".modal-body",
                      "reached-bottom": () => {
                        return _vm.getNextTalents(_vm.searchParams)
                      },
                    },
                  },
                  [
                    _c("pickstar-loading", {
                      attrs: { slot: "loading" },
                      slot: "loading",
                    }),
                    _vm._v(" "),
                    _c("span", {
                      attrs: { slot: "finished" },
                      slot: "finished",
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _c(
                  "button",
                  {
                    ref: "closeButton",
                    staticClass: "btn btn-lg btn-danger pull-left",
                    attrs: { type: "button", "data-dismiss": "modal" },
                  },
                  [_c("i", { staticClass: "fa fa-close" }), _vm._v(" Cancel")]
                ),
                _vm._v(" "),
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-lg btn-primary",
                    attrs: {
                      type: "button",
                      click: _vm.handleSaveAdditionalTalentCallback,
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-check" }),
                    _vm._v(" Save\n        "),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }